import React from "react"
import HomepageData from "./data/extendedhomepage.json"
import Styles from "./css/extendedhomepage.module.scss"
import {isChrome,isFirefox,isIeEdge,isSafari, getBrowser} from "@tightrope/lpscripts/browserdetect"

class ExtendedHomepage extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      isChrome: isChrome(),
      isFirefox: isFirefox(),
      isIeEdge: isIeEdge(),
      isSafari: isSafari(),
      display: 'none',
      pageData: props.data,
      data: HomepageData
    }
    this.browserRef = React.createRef();
    this.overlayRef = React.createRef();
    this.bannerRef = React.createRef();
  }

  triggerAnimation = () => {
    // Remove animation classes
    this.browserRef.current.classList.remove(Styles.animateSequence);
    this.bannerRef.current.classList.remove(Styles.featureBuzz);
    this.overlayRef.current.classList.remove(Styles.animateSequence);

    // Force reflow to restart animations
    void this.browserRef.current.offsetWidth;
    void this.overlayRef.current.offsetWidth;

    // Add animation classes back
    this.browserRef.current.classList.add(Styles.animateSequence);
    this.bannerRef.current.classList.add(Styles.featureBuzz);
    this.overlayRef.current.classList.add(Styles.animateSequence);
  }

  headline(data){
    let params = new URLSearchParams(window.location.search);
    let hc = params.get("hc");
    let kw = params.get("kw");
    let bn = params.get("bn");
    let qsData = {};
    if(hc){
      qsData.headline = hc;
    }
    if(kw){
      qsData.subhead = kw;
    }
    if(bn){
      qsData.mainCTA = bn;
    }
    if(qsData){
      const queryData = Object.assign(data, qsData);
      this.setState({data: queryData});
    }
  }

  showBrowsers(browsers){
    let display = false;
    if(getBrowser() === 'ie' && browsers.includes('ie')){
      display=true;
    }
   else if(getBrowser() === 'firefox' && browsers.includes('firefox')){
      display=true;
    }
   else if(getBrowser() === 'chrome' && browsers.includes('chrome')){
      display=true;
    }
   else if(getBrowser() === 'edge' && browsers.includes('edge')){
      display=true;
    }
  else if (getBrowser() === "safari" && browsers.includes("safari")) {
          display = true;
    }
   else if(getBrowser() === 'other' && browsers.includes('other')){
      display=true;
    }
    if(display)
      this.setState({display: 'block'});
    else
      this.setState({display: 'none'});
  }

  componentDidMount() {
    this.props.data.then(data => {
      const instanceData = Object.assign(this.state.data, data);
      this.setState({ data: instanceData});
      this.state.isChrome = isChrome();
      this.state.isFirefox = isFirefox();
      this.state.isIeEdge = isIeEdge();
      this.state.isSafari = isSafari();

      if(isChrome()){
        const browserData = Object.assign(this.state.data, this.state.data.chrome);
        this.setState({data: browserData});
      }
      if(isFirefox()){
        const browserData = Object.assign(this.state.data, this.state.data.firefox);
        this.setState({data: browserData});
      }
      if (isSafari()) {
          const browserData = Object.assign(this.state.data, this.state.data.safari);
          this.setState({ data: browserData });
      }
      if (isIeEdge()) {
          const browserData = Object.assign(this.state.data, this.state.data.edge);
          this.setState({ data: browserData });
      }
      this.headline(this.state.data);
      if(this.props.browsers){
        this.showBrowsers(this.props.browsers);
      }
      else{
        this.setState({display: 'block'});
      }

      // Start animation immediately
      this.triggerAnimation();

      // Set up interval for animation
      this.animationInterval = setInterval(this.triggerAnimation, 5000);
    });
  }

  componentWillUnmount() {
    // Clean up interval when component unmounts
    if (this.animationInterval) {
      clearInterval(this.animationInterval);
    }
  }

  render() {
    const featureIcons = {
      capture: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
          focusable="false"
        >
          <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path>
          <circle cx="12" cy="13" r="4"></circle>
        </svg>
      ),
      recording: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
          focusable="false"
        >
          <path d="M23 7l-7 5 7 5V7z"></path>
          <rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect>
        </svg>
      ),
      search: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
          focusable="false"
        >
          <circle cx="11" cy="11" r="8"></circle>
          <path d="m21 21-4.35-4.35"></path>
        </svg>
      )
    }
    const bottomTiles = [
      {
        id: "label1",
        icon: "capture",
        title: this.state.data.freedomHead1,
        description: this.state.data.freedomPara1
      },
      {
        id: "label2",
        icon: "recording",
        title: this.state.data.freedomHead2,
        description: this.state.data.freedomPara2
      },
      {
        id: "label3",
        icon: "search",
        title: this.state.data.freedomHead3,
        description: this.state.data.freedomPara3
      }
    ]
    return (
      <div className = {Styles.extendedhomepage}  style={{ display: this.state.display }} >
      <div className = {Styles.allContainer}>
      <header>
      <p className = {Styles.productType}>{this.state.data.productType}</p>
      </header>
      <section className={Styles.banner}>
      <video className={Styles.bannerVideo} autoPlay loop muted playsInline>
        <source src="/img/Woman_Working_Happily_at_Home.webm" type="video/webm" />
      </video>
      <div className={Styles.bannerOverlay}></div>
      <div className = {Styles.bannerContent}>
        <div className = {Styles.bannerRight}>
          <img className = {Styles.bannerCrunched} src={this.state.data.bannerCrunched}/>
          <h1 className = {Styles.headline}>{this.state.data.productHeadline}</h1>
          <h2>{this.state.data.subhead}</h2>
          <button onClick = {() => { window.triggerInstall()}} data-cy="cta" className = {`st2 bn_param cws_dl cl1`}><span dangerouslySetInnerHTML={{ __html: this.state.data.mainCTA }}></span></button>
          {this.props.children}
        </div>
      </div>
      </section>

      <div className = {Styles.middle}>
      <div className={Styles.fakeBrowser} ref={this.browserRef}>
        <div className={Styles.browserTop}>
        </div>
        <div className={Styles.browserHeader}>
          <div className={Styles.browserAddress}></div>
          <img src={this.state.data.fakePuzzle} alt="" className={Styles.fakePuzzle}/>
          <img src={this.state.data.icon} alt="" className={Styles.icon}/>
          <img src={this.state.data.pointy} alt="" className={Styles.pointy}/>
          <img src={this.state.data.fakePancake} alt="" className={Styles.fakePancake}/>
        </div>
        <div className={Styles.fakeContent}>
          <div className={`${Styles.imagePlaceholder} ${Styles.placeholder}`}></div>
          <div className={`${Styles.titlePlaceholder} ${Styles.placeholder}`}></div>
          <div className={`${Styles.textPlaceholder} ${Styles.placeholder}`}></div>
          <div className={`${Styles.textPlaceholder} ${Styles.placeholder}`}></div>
          <div className={`${Styles.textPlaceholder} ${Styles.placeholder}`}></div>
        </div>
        <div className={Styles.fakeContent}>
          <div className={`${Styles.titlePlaceholder} ${Styles.placeholder}`}></div>
          <div className={`${Styles.textPlaceholder} ${Styles.placeholder}`}></div>
          <div className={`${Styles.textPlaceholder} ${Styles.placeholder}`}></div>
          <div className={`${Styles.textPlaceholder} ${Styles.placeholder}`}></div>
          <div className={`${Styles.imagePlaceholder} ${Styles.placeholder2}`}></div>
        </div>
        <div className={Styles.fakeContent}>
          <div className={`${Styles.imagePlaceholder} ${Styles.placeholder}`}></div>
          <div className={`${Styles.titlePlaceholder} ${Styles.placeholder}`}></div>
          <div className={`${Styles.textPlaceholder} ${Styles.placeholder}`}></div>
          <div className={`${Styles.textPlaceholder} ${Styles.placeholder}`}></div>
          <div className={`${Styles.textPlaceholder} ${Styles.placeholder}`}></div>
        </div>
        <div className={Styles.fakeBannerOverlay} ref={this.overlayRef}>
          <div className={Styles.fakeFeatureBanner} ref={this.bannerRef}>
            <img src="/img/bam_img.png" alt="Better Screenshot feature highlight" />
          </div>
        </div>
      </div>
      <div className={Styles.contentRight}>
      <h3>{this.state.data.mid2Headline}</h3>
      <h4>{this.state.data.mid2Sub1}</h4>
      <p>{this.state.data.mid2Line1}</p>
      <h4>{this.state.data.mid2Sub3}</h4>
      <p>{this.state.data.mid2Line3}</p>
      </div>

      </div>

      <div className = {Styles.bottom}>
      		<h3 className = {Styles.headlineMid}> {this.state.data.freedom}</h3>
          <div>
      		{bottomTiles.map(tile => (
            <div key={tile.id} className = {Styles.bottomTile}>
              <div className={Styles.bottomTileIcon}>
                {featureIcons[tile.icon]}
              </div>
              <h4 id={tile.id}>{tile.title}</h4>
              <p>{tile.description}</p>
            </div>
          ))}
          </div>
      </div>

      <div className = {Styles.chunkyFooter}>
      <span></span>
   <span></span>
   <span></span>
   <span></span>
   <span></span>
   <span></span>
   <span></span>
   <span></span>
   <span></span>
   <span></span>
   <span></span>
   <span></span>
   <span></span>
   <span></span>
   <span></span>
   <span></span>
   <span></span>
   <span></span>
   <span></span>
   <span></span>
        <div>
          <h6>{this.state.data.footerHead}</h6>
          <p>{this.state.data.footerPara}</p>

        <button onClick = {() =>  { window.triggerInstall()} } data-cy="cta" className = {`st2 bn_param cws_dl cl1`} dangerouslySetInnerHTML={{ __html: this.state.data.mainCTA }}></button>
        <div class="footerDisc">{this.props.children}</div>
        </div>
        <img alt='Better Screenshot' src={this.state.data.modalImg} className = {Styles.modalImg} />
        {/* <video className={Styles.howToVideo} loop autoPlay muted><source src={this.state.data.clearLaptop}></source></video> */}
        </div>
      </div>
    </div>
    )
  }
}
export default ExtendedHomepage
